// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3111r","col":"styles_col__4tfTI"};